import { DateRange } from '@/types';
import {
  AssetItemDB,
  IncidentItemDB,
  IncidentTagItemDB,
  IncidentTypeItemDB,
  SeverityItemDB,
} from './BigQueryIncidentsClient.types.db';
import { Timestamp } from './GoogleBigQueryClient.types';

export type { OrgParams } from './GoogleBigQueryClient.types';

export enum TargetType {
  Asset = 'Asset',
  Incident = 'Incident',
}

type Lat = number;
type Lng = number;
export type CoordBounds = [[Lat, Lat], [Lng, Lng]];

export interface IncidentFilterOptions {
  ids?: IncidentItemDB['IncidentID'][];
  coordBounds?: CoordBounds;
  incidentTypeID?: IncidentItemDB['IncidentTypeID'][];
  severityLevel?: IncidentItemDB['SeverityLevel'][];
  dateRange?: DateRange[];
  incidentLocations?: string[];
  verificationSources?: IncidentItemDB['VerificationSource'][];
  industries?: IncidentItemDB['Industry'][];
}

export interface LocationTarget {
  _targetType: TargetType;
}

export interface AssetItem extends AssetItemDB, LocationTarget {}

export interface IncidentItem
  extends Pick<
      IncidentItemDB,
      | 'IncidentID'
      | 'City'
      | 'Region'
      | 'Address'
      | 'Country'
      | 'Photo'
      | 'IncidentDescription'
      | 'IncidentTypeID'
      | 'IncidentTypeName'
      | 'Latitude'
      | 'Longitude'
      | 'Title'
      | 'DataSource'
      | 'Hyperlink'
      | 'SeverityLevel'
      | 'VerificationSource'
      | 'Industry'
      | 'GSI'
      | 'SupplyChainMapping'
    >,
    LocationTarget {
  IncidentDateTime: Timestamp;
  Tags: IncidentTagItemDB['IncidentTagsName'][];
}

export interface IncidentFeedItem
  extends Pick<
    IncidentItem,
    | 'IncidentID'
    | 'City'
    | 'Country'
    | 'Address'
    | 'IncidentDateTime'
    | 'IncidentDescription'
    | 'IncidentTypeID'
    | 'IncidentTypeName'
    | 'SeverityLevel'
    | 'Latitude'
    | 'Longitude'
    | 'Title'
    | 'Tags'
    | 'DataSource'
    | 'Hyperlink'
    | 'GSI'
    | '_targetType'
  > {}

export interface IncidentTypeItem extends IncidentTypeItemDB {}

export interface SeverityItem extends SeverityItemDB {}

export interface IncidentTagItem extends IncidentTagItemDB {}

export interface AssetDecisionItemDB {
  DecisionID: string;
  DecisionSourceId: string;
  AssetID: string;
  DecisionDateTime: { value: string };
  Title: string;
  DecisionDescription: string | null;
  DecisionTypeName: string;
  DecisionSeverityName: string;
  Tags: string;
}

export interface AssetDecisionItem extends Omit<AssetDecisionItemDB, 'Tags'> {
  Tags: string[];
}

export type IncidentDistinctField = keyof Pick<IncidentItem, 'VerificationSource' | 'Industry'>;

export type IncidentsDateTimeRange = {
  min: Timestamp | null;
  max: Timestamp | null;
};
